import styled, { createGlobalStyle } from 'styled-components'
import {
  TextValidator,
  SelectValidator
} from 'react-material-ui-form-validator'
import Select from '@material-ui/core/Select'

import theme from './theme'

export const GlobalStyle = createGlobalStyle`
  body {
    .sweet-overlay, .sweet-alert{
      position: fixed !important;
    }
    background: #eeeeee !important;
  }
`
interface propsIButton {
  width: number
  background?: string
}

interface propsStyleError {
  errorstyle?: string
}

interface propsContainer {
  background?: string
}

interface propsStatus {
  status: string
}

export const Container = styled.div<propsContainer>`
  background: ${propsContainer => propsContainer.background};
  border-radius: 10px;
  margin: 5px;
  padding: 10px;
`
export const ParagraphTitle = styled.p`
  color: ${theme.palette.primary.main};
  font-weight: bold;
  margin-top: -5px;
`
export const ParagraphTitleMessage = styled.p`
  color: ${theme.palette.error.main};
  font-weight: bold;
  margin-top: -5px;
`

export const IButton = styled.button<propsIButton>`
  background: ${props =>
    props.background ? props.background : theme.palette.primary.main};
  border: 0;
  height: 40px;
  width: ${props => `${props.width}px`};
  border-radius: 6px;
  font-weight: bold;
  font-size: 15px;
  color: #fff;
  margin: 5px;
  outline: none;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
    transition: opacity 0.3s;
  }
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
`
export const InputText = styled(TextValidator)`
  margin: 10px;
  width: calc(100% - 20px);
  input {
    background: #fff;
    border-radius: 5px;
  }
  .MuiInputBase-root {
    background: #fff;
  }
`
export const InputSelect = styled(SelectValidator)<propsStyleError>`
  width: calc(100% - 20px);
  height: 56px;
  margin: 10px;
  .MuiSelect-selectMenu {
    background: #fff;
    ${propsStyleError => propsStyleError.errorstyle};
  }
`
export const MaterialSelect = styled(Select)<propsStyleError>`
  width: calc(100% - 20px);
  height: 56px;
  .MuiSelect-selectMenu {
    background: #fff;
    width: 100%;
    ${propsStyleError => propsStyleError.errorstyle};
  }
`
export const ButtonSend = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  margin-top: 20px;
`
export const styleError = { border: '1px solid #ff1744', borderRadius: 5 }

export const TextError = styled.p`
  color: #ff1744;
  font-size: 0.75rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  margin-left: 14px;
  margin-right: 14px;
  margin-top: 3px;
  text-align: left;
`
export const TextAlert = styled.p`
  color: #ffbd00;
  font-weight: bold;
  margin-top: -5px;
`

const statusStringViews = (status: string) => {
  switch (status) {
    case 'PendenteFornecedor':
      return 'Pendente Fornecedor'
    case 'Pendente':
      return 'Pendente Central'
    default:
      return status
  }
}

export const StatusColor = styled.div<propsStatus>`
  text-align: center;
  padding: 6px 10px 5px;
  color: #fff;
  border-radius: 20px;
  max-width: 250px;
  background-color: ${props =>
    props.status.toLocaleLowerCase() === 'pendente' || 
    props.status.toLocaleLowerCase() === 'pendentefornecedor'
      ? '#2196f3'
      : props.status.toLocaleLowerCase() === 'aprovado'
      ? '#40d991'
      : props.status.toLocaleLowerCase() === 'vencido'
      ? '#fbb954'
      : props.status.toLocaleLowerCase() === 'reprovado'|| 
      props.status.toLocaleLowerCase() ==='faltantes'
      ? '#f44336'
      : props.status.toLocaleLowerCase() ==='arquivado'
      ? '#fbc02d'
      : ''};
  ::after {
    content: ${props => "'" + statusStringViews(props.status) + "'"};
  }
`
